const hours = [
  { value: null, text: 'Seleccione una hora de expiración' },
  { value: '00', text: '00 AM' },
  { value: '01', text: '01 AM' },
  { value: '02', text: '02 AM' },
  { value: '03', text: '03 AM' },
  { value: '04', text: '04 AM' },
  { value: '05', text: '05 AM' },
  { value: '06', text: '06 AM' },
  { value: '07', text: '07 AM' },
  { value: '08', text: '08 AM' },
  { value: '09', text: '09 AM' },
  { value: '10', text: '10 AM' },
  { value: '11', text: '11 AM' },
  { value: '12', text: '12 PM' },
  { value: '13', text: '13 PM' },
  { value: '14', text: '14 PM' },
  { value: '15', text: '15 PM' },
  { value: '16', text: '16 PM' },
  { value: '17', text: '17 PM' },
  { value: '18', text: '18 PM' },
  { value: '19', text: '19 PM' },
  { value: '20', text: '20 PM' },
  { value: '21', text: '21 PM' },
  { value: '22', text: '22 PM' },
  { value: '23', text: '23 PM' }
];
export default hours;
